import React from "react"
import { recordEvent } from "../../apis/googleAnalytics"
import KeyPassages from "./../../data/newKeyPassages.json"
import ValuesPassages from "./../../data/YWAMValues.json"

const highlightColors = {
  CEL: "#f9d7fb",
  COM: "#eed7fb",
  ECO: "#fbe9d7",
  EDU: "#d7fbf8",
  FAM: "#fbcaca",
  GOV: "#fafbca",
  REL: "#d8fbca",
  BEL: "#fbe9d7",
  VAL: "#fafbca",
}

const Highlight = ({
  type,
  id,
  isText,
  newSphereViewDialog,
  newValuesDialog,
  versionRef,
  children,
}) => {
  if (!id) return <span>{children}</span>
  const data = type === "KeyPassage" ? KeyPassages[id] : ValuesPassages[id]
  const keyPassageNum = type === "KeyPassage" ? id.substring(4, 6) : null
  const doubleHighlight =
    type === "KeyPassage" ? parseInt(keyPassageNum) > 46 : false

  let highlight = ""
  if (doubleHighlight) {
    highlight = `repeating-linear-gradient(${
      highlightColors[data.spheres[0]]
    }, ${highlightColors[data.spheres[0]]} 49.9%, ${
      highlightColors[data.spheres[1]]
    } 50.1%, ${highlightColors[data.spheres[1]]} 100%)`
  } else {
    highlight =
      highlightColors[
        type === "KeyPassage" ? data.spheres[0] : id.substring(0, 3)
      ]
  }

  let backgroundColor = ""
  if (!doubleHighlight) {
    backgroundColor =
      highlightColors[
        type === "KeyPassage" ? data.spheres[0] : id.substring(0, 3)
      ]
  } else {
    backgroundColor = highlightColors[data.spheres[1]]
  }

  return (
    <span
      style={{
        background: highlight,
        boxShadow: backgroundColor ? `0px 1px 0px 0px ${backgroundColor}` : "",
        whiteSpace: "pre-wrap",
        height: "25px",
        textDecoration:
          type === "KeyPassage" && data.spheres[0] === "FOU" ? "underline" : "",
        fontWeight:
          type === "KeyPassage" && data.spheres[0] === "FOU" ? "bold" : "",
      }}
      onClick={
        !isText
          ? null
          : () => {
              recordEvent(
                `${type} Popup`,
                versionRef,
                data.id
              )
              if (type === "KeyPassage") {
                newSphereViewDialog({
                  open: true,
                  content: data,
                })
              } else {
                newValuesDialog({
                  open: true,
                  content: data,
                })
              }
            }
      }
    >
      {children}
    </span>
  )
}

export default Highlight
